(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dmg-addon-list"] && !Shopify.designMode) return;
  try {
    if (!window.dmgAddonComponentsLoaded) {
    window.dmgAddonComponentsLoaded = true;

    const publishDmgAddonEvent = (eventName, payload) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...payload });
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
      }
    };

    const observeAddonLists = () => {
      document.querySelectorAll('[data-dmg-addon-list]:not([data-dmg-observed])').forEach((list) => {
        list.dataset.dmgObserved = 'true';
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          const items = Array.from(list.querySelectorAll('[data-dmg-addon-card]')).map((card, index) => ({
            product_id: card.dataset.productId,
            position: index + 1,
          }));
          publishDmgAddonEvent('dmg_addon_impression', { context: list.dataset.context, items });
          observer.disconnect();
        }, { threshold: 0.25 });
        observer.observe(list);
      });
    };

    const initialiseAddonCarousels = () => {
      document.querySelectorAll('[data-dmg-addon-list]:not([data-dmg-carousel-ready])').forEach((list) => {
        const track = list.querySelector('.dmg-addons__track');
        const controls = list.querySelector('[data-dmg-addon-controls]');
        const previous = list.querySelector('[data-dmg-addon-previous]');
        const next = list.querySelector('[data-dmg-addon-next]');
        if (!track || !controls || !previous || !next) return;

        list.dataset.dmgCarouselReady = 'true';

        const updateControls = () => {
          const maximumScroll = track.scrollWidth - track.clientWidth;
          const hasOverflow = maximumScroll > 2;
          controls.hidden = !hasOverflow;
          previous.disabled = !hasOverflow || track.scrollLeft <= 2;
          next.disabled = !hasOverflow || track.scrollLeft >= maximumScroll - 2;
        };

        const scrollTrack = (direction) => {
          const firstCard = track.querySelector('[data-dmg-addon-card]');
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap) || 0;
          const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth;
          track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
        };

        previous.addEventListener('click', () => scrollTrack(-1));
        next.addEventListener('click', () => scrollTrack(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        new ResizeObserver(updateControls).observe(track);
        updateControls();
      });
    };

    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-dmg-addon-variant]');
      if (!select) return;
      const price = select.selectedOptions[0]?.dataset.price;
      const card = select.closest('[data-dmg-addon-card]');
      if (price && card) card.querySelector('[data-dmg-addon-price]').textContent = price;
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-dmg-addon-link]');
      if (!link) return;
      const card = link.closest('[data-dmg-addon-card]');
      const list = link.closest('[data-dmg-addon-list]');
      publishDmgAddonEvent('dmg_addon_click', {
        context: list?.dataset.context,
        product_id: card?.dataset.productId,
      });
    });

    document.addEventListener('submit', (event) => {
      const component = event.target.closest('[data-dmg-addon-form]');
      if (!component) return;
      const variantInput = event.target.querySelector('[name="id"]');
      publishDmgAddonEvent('dmg_addon_add_to_cart', {
        context: component.dataset.context,
        product_id: component.dataset.productId,
        product_title: component.dataset.productTitle,
        variant_id: variantInput?.value,
      });
    }, true);

    observeAddonLists();
    initialiseAddonCarousels();
    document.addEventListener('shopify:section:load', () => {
      observeAddonLists();
      initialiseAddonCarousels();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
